// src/services/teacherService.js
import { useApi } from '../composables/useApi.js';

export const setupTeacherAccount = async (teacherData) => {
  const response = await useApi().post('/teacher/onboarding', teacherData);
  console.log('API CALL SUCCESS: Teacher onboarding successful.', response);
  return response;
};
